/**
 * 该文件用于处理错误提示的VNode结构
 */
import { h } from 'vue'

/**
 * VNode错误消息工厂类
 */
class VNodeErrMsgFactory {
  static styles = {
    lineHeight: 'line-height: 20px',
    textColor: 'color: #646566'
  }

  /**
   * 创建VNode结构
   * @param type VNode类型
   * @param value VNode实际展示内容
   * @returns VNode对象
   */
  static createVNode(type, value) {
    const { lineHeight, textColor } = this.styles
    const vNodeMap = {
      titleMsg: () => h('p', { style: lineHeight }, value),
      otherMsg: () => h('p', { style: `${textColor};${lineHeight};word-wrap: break-word;` }, value),
      requestId: () => h('span', { style: `${textColor};${lineHeight}` }, `错误码: ${value}`),
      topLevelContainer: () => h('div', { style: 'min-width: 280px; padding-right: 24px;' }, value)
    }

    return vNodeMap[type] ? vNodeMap[type]() : h('span', {}, '')
  }
}

/**
 * 获取最终的VNode结构
 * @param requestId 唯一请求ID
 * @param errMsg 错误信息
 * @returns 最终的错误提示VNode结构
 */
const getVNodeMsg = (requestId, errMsg) => {
  const firstIndex = errMsg.indexOf(':')
  const vNodeMsgTitle = VNodeErrMsgFactory.createVNode(
    'titleMsg',
    firstIndex !== -1 ? errMsg.substring(0, firstIndex) : errMsg
  )
  const vNodeMsgCommon = VNodeErrMsgFactory.createVNode(
    'otherMsg',
    '抱歉，您当前访问的服务暂时不可用，可复制如下错误码，联系技术支持人员处理。'
  )
  const vNodeMsgOther =
    firstIndex !== -1
      ? VNodeErrMsgFactory.createVNode('otherMsg', errMsg.substring(firstIndex + 1))
      : null
  const vNodeRequestId = VNodeErrMsgFactory.createVNode('requestId', requestId)

  return VNodeErrMsgFactory.createVNode('topLevelContainer', [
    vNodeMsgTitle,
    vNodeMsgOther,
    vNodeMsgCommon,
    vNodeRequestId
  ])
}

export default getVNodeMsg
